import { Record } from 'immutable';

export const Profile = new Record({
    success: false,
    isPending: false,
    error: null,
    data: {}
});